import { useState } from 'react';
import { Alert, Button, buttonClass } from '@edil/ui';
import { TELEGRAM_BOT } from '@/lib/config';
import { canSharePhone, sharePhone, type ShareResult } from '@/lib/share-phone';
import { useApp } from './app-provider';

/**
 * Telegram players who have not shared their phone cannot buy or deposit (server rule
 * auth.telegram_phone_required). This asks for it on every screen until they do: one tap in the
 * Mini App, or the bot's "Share phone number" button on the website.
 */
export function PhoneGate() {
  const { api, t, me, refreshMe, telegram, toast } = useApp();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<ShareResult | null>(null);
  if (!me || !me.telegram_linked || me.phone_verified) return null;

  async function share() {
    setBusy(true);
    const res = await sharePhone(telegram, async () => {
      const profile = await api.GET('/v1/me');
      return Boolean(profile.data?.phone_verified);
    });
    setBusy(false);
    setResult(res);
    if (res === 'shared') {
      await refreshMe();
      toast(t('phone.verified'), 'success');
    }
  }

  const inApp = canSharePhone(telegram);
  return (
    <div style={{ marginBottom: 'var(--space-5)' }} data-testid="phone-gate">
      <Alert
        tone="warning"
        title={t('phone.share_title')}
        action={
          inApp ? (
            <Button size="sm" loading={busy} onClick={() => void share()}>
              {busy ? t('phone.waiting') : t('phone.share_button')}
            </Button>
          ) : (
            TELEGRAM_BOT && (
              <a className={buttonClass('primary', 'sm')} href={`https://t.me/${TELEGRAM_BOT}?start=verify`} target="_blank" rel="noopener noreferrer">
                {t('profile.open_bot')}
              </a>
            )
          )
        }
      >
        {result === 'declined' || result === 'timeout' || result === 'unsupported' ? t(`phone.${result}`) : t('phone.gate')}
        {me.verify_message && <div style={{ marginTop: 4 }}>{me.verify_message}</div>}
      </Alert>
    </div>
  );
}
